export default {
  ADD_REACTION: (state, reaction) => {
    state.reactions.push(reaction);
  },

  REMOVE_REACTION: (state) => {
    state.reactions.shift();
  }
};
